import { useEffect, useState } from "react";
import PartsTableComponent from "../AssistancePart/PartsTableComponent";
import PartsInsertComponent from "../AssistancePart/PartsInsertComponent";
import { AssistancePartsNavBar } from "../AssistancePart/AssistancePartsNavBar";
import { Collapse } from "@mui/material";
import { FcCollapse, FcExpand } from "react-icons/fc";
import { FormattedMessage } from "react-intl";
import { Row } from "reactstrap";
import { useAvailableModulesContext } from "../../context/AvailableModulesContext";
import { useAuth } from "../../context/AuthContext";

type AssistancePartsComponentType = {
    assistanceId: number;
    reloadExecutions: boolean;
    mode: "workshop" | "backoffice";
    isComplete: boolean;
    isAcceptedBudget: boolean;
    assistanceStatus: string;
}

export function AssistancePartsComponent({ assistanceId, reloadExecutions, mode, isComplete, isAcceptedBudget , assistanceStatus }: AssistancePartsComponentType) {


    const [activeTab, setActiveTab] = useState<number>(0);
    const [goToPage, setGoToPage] = useState<number>(1);
    const [currentPage, setCurrentPage] = useState<number>(1);
    const [querySearch, setQuerySearch] = useState<string>("");
    const [reload, setReload] = useState<boolean>(false);
    const [reloadParts, setReloadParts] = useState<boolean>(false);
    const [selectParts, setSelectParts] = useState<boolean>(true);
    const [requestParts, setRequestParts] = useState<boolean>(true);

    const { availableModules } = useAvailableModulesContext();
    const [canTechnicianAddParts, setCanTechnicianAddParts] = useState<boolean>(false);
    //effect    
    useEffect(() => {
        if (availableModules.includes("CanTechnicianAddParts")) {
            setCanTechnicianAddParts(true);
        }
    }, []);

    const { isTechnician, isAdmin, isAdministrative } = useAuth();

    return (
        <>
            <div className="pageComponent">
                { /* Se for tecnico, pode ver se setting for true */}
                {isTechnician() && !canTechnicianAddParts ? (
                    null
                ) :
                    < Row style={{ margin: "0px" }}>
                        <span
                            className="pageSubHeaderBlockGray"
                            onClick={() => setSelectParts(!selectParts)}>
                            <FormattedMessage id="Screens.Part.SearchParts" />
                            <div className="CollapseIcon">
                                {" "}
                                {selectParts ? <FcCollapse /> : <FcExpand />}
                            </div>
                        </span>
                        <Collapse in={selectParts} unmountOnExit>
                            <PartsInsertComponent
                                assistanceId={assistanceId}
                                setQuerySearch={setQuerySearch}
                                querySearch={querySearch}
                                setGoToPage={setGoToPage}
                                setCurrentPage={setCurrentPage}
                                setReloadParts={setReloadParts}
                                reloadParts={reloadParts}
                                isComplete={isComplete}
                                isAcceptedBudget={isAcceptedBudget}
                            />
                            <PartsTableComponent
                                assistanceId={assistanceId}
                                reloadParts={reloadParts}
                                querySearch={querySearch}
                                setGoToPage={setGoToPage}
                                goToPage={goToPage}
                                setCurrentPage={setCurrentPage}
                                currentPage={currentPage}
                                setReload={setReload}
                                reload={reload}
                                setActiveTab={setActiveTab}
                                isComplete={isComplete}
                                isAcceptedBudget={isAcceptedBudget}
                                assistanceStatus = {assistanceStatus}
                            />
                        </Collapse>
                    </Row>
                }
            </div >

            <div className="pageComponent">
                <Row style={{ margin: "0px" }}>
                    <span
                        className="pageSubHeaderBlockGray"
                        onClick={() => setRequestParts(!requestParts)}>
                        <FormattedMessage id="Screens.Part.Parts" />
                        <div className="CollapseIcon">
                            {" "}
                            {requestParts ? <FcCollapse /> : <FcExpand />}
                        </div>
                    </span>

                    <Collapse in={requestParts} unmountOnExit>
                        <AssistancePartsNavBar
                            mode={"backoffice"}
                            assistanceId={assistanceId}
                            reload={reload}
                            setActiveTab={setActiveTab}
                            activeTab={activeTab}
                            isComplete={isComplete}
                            isAcceptedBudget={isAcceptedBudget}
                            assistanceStatus = {assistanceStatus}
                        />
                    </Collapse>
                </Row>
            </div>
        </>
    )
}
